import { cn } from './cn.js';

import type { ReactElement } from 'react';

interface AssigneePillsProps {
  names: string | null;
  max?: number;
  className?: string;
}

function formatName(raw: string): string {
  if (raw.length <= 1) {
    return raw;
  }
  const first = raw.charAt(0);
  const rest = raw.slice(1).toLowerCase();
  return `${first}. ${rest.charAt(0).toUpperCase()}${rest.slice(1)}`;
}

function parseName(raw: string | null): string[] {
  if (raw === null || raw === '') {
    return [];
  }
  return raw
    .split(';')
    .map((s) => s.trim())
    .filter(Boolean)
    .map(formatName);
}

export function AssigneePills({ names, max = 2, className }: AssigneePillsProps): ReactElement {
  const parsed = parseName(names);

  if (parsed.length === 0) {
    return <span className="text-text-tertiary">{'\u2014'}</span>;
  }

  const visible = parsed.slice(0, max);
  const overflow = parsed.length - max;

  return (
    <div className={cn('flex items-center gap-1 flex-wrap', className)}>
      {visible.map((name, i) => (
        <span
          key={i}
          className={cn(
            'inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium',
            'bg-[var(--glass-bg-strong)] text-text-secondary border border-[var(--glass-border-subtle)]',
            'backdrop-blur-sm whitespace-nowrap',
          )}
        >
          {name}
        </span>
      ))}
      {overflow > 0 && (
        <span
          className={cn(
            'inline-flex items-center px-1.5 py-0.5 rounded-full text-[11px] font-medium',
            'bg-primary-soft text-primary border border-primary/20',
            'backdrop-blur-sm',
          )}
        >
          +{String(overflow)}
        </span>
      )}
    </div>
  );
}
